import React from 'react';

function Paging(props: any) {
    const { page, listItem, onPageChange } = props;
    return (
        <div className="row pt-4">
            <div className="col-lg-6 col-md-6 col-6">
                <button type="button" onClick={onPageChange} data-type='-' disabled={page === 1} className="rounded-lg px-4 py-2 border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-blue-100 duration-300">Prev</button>
            </div>
            <div className="col-lg-6 col-md-6 col-6">
                <button type="button" onClick={onPageChange} data-type='+'  className="rounded-lg px-4 py-2 border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-blue-100 duration-300 float-right">Next</button>
            </div>
        </div>
    )
}

export default Paging;